import {z} from 'zod';

export const CustomerOrderFormSchema = z.object({
  number: z.string(),
  authorizationProfileIds: z.array(z.string()),
  validFrom: z.date().nullish(),
  validTo: z.date().nullish(),
  value: z.number().min(0).nullish(),
  remainingValue: z.number().min(0).nullish(),
  note: z.string().nullish(),
});

export type CustomerOrderForm = z.infer<typeof CustomerOrderFormSchema>;
